const companyRouter = [
    {
        path: "list-company",
        name: "company",
        component: () => import("@/views/admin/company"),
        default: true,
        meta: {
            model: "company",
            // requiresAuth: true,
        },
    },
    {
        path: "list-company/add",
        name: "addCompany",
        component: () => import("@/views/admin/company/function"),
        default: true,
        meta: {
            model: "company",
            // requiresAuth: true,
        },
    },
    {
        path: "list-company/edit/:id",
        name: "editCompany",
        component: () => import("@/views/admin/company/function"),
        default: true,
        meta: {
            model: "company",
            // requiresAuth: true,
        },
    },
];
export default companyRouter;